import { CustomerDTO } from "@/modules/clients/dtos";
import {
  Button,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { HandCoins, Play } from "lucide-react";
import { useStartWorkflow } from "../hooks/use-start-workflow.hook";
import { primaryButtonSx } from "./field-shell";

/**
 * Empty-state entry point: trigger a new Nawy Now flow instance for the current lead.
 * Goes through crm-backend (externalRef = lead uid), which sources the customer itself
 * and creates the workflow-manager case WITH its PRIMARY participant.
 */
const StartWorkflowCard = ({
  client,
  leadUid,
}: {
  client: CustomerDTO;
  leadUid: string;
}) => {
  const theme = useTheme();
  const colors = theme.nawy.colors;
  const { create } = useStartWorkflow();

  const handleStart = () =>
    create.mutate({ customerUid: client.uid, leadUid });

  return (
    <Stack spacing={1.5} alignItems="center" sx={{ py: 10 }}>
      <HandCoins size={40} color={colors.semantic.text.tertiary} />
      <Typography sx={{ fontSize: 14, lineHeight: "20px", fontWeight: 600 }}>
        No Nawy Now flow for this lead
      </Typography>
      <Typography variant="body2" color={colors.semantic.text.secondary}>
        Trigger the loan process to start tracking it here.
      </Typography>

      {/* §MobileQA: `contained` with only textTransform rendered MUI's default primary
          (#1976d2) — the brand accent is #015C9A. */}
      <Button
        variant="contained"
        disableElevation
        startIcon={
          create.isLoading ? <CircularProgress size={14} /> : <Play size={16} />
        }
        disabled={create.isLoading}
        onClick={handleStart}
        sx={{ ...primaryButtonSx(theme), textTransform: "none" }}
      >
        Start Nawy Now flow
      </Button>
    </Stack>
  );
};

export default StartWorkflowCard;
